import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex items-center overflow-x-hidden',
    first: 'whitespace-nowrap',
    second: 'whitespace-nowrap'
  },
  variants: {
    active: {
      true: {
        first: 'animate-scrolling px-6',
        second: 'animate-scrolling2 absolute px-6'
      },
      false: {
        base: 'flex-center text-center',
        second: 'hidden'
      }
    }
  },
  defaultVariants: {
    active: false
  }
});
